import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { purchaseGiftCardAction } from "../../../../../../redux/services/wallet-info/walletInfoServices";
import GiftCardPaymentDetails from "./GiftCardPaymentDetails";
import withStripePayment from "../../../../../common/with-stripe-payment/withStripePayment";
import { getAllCardsAction, getPaymentIntentAction } from "../../../../../../redux/services/payments/paymentServices";
import Spinner from "../../../../../common/spinner/Spinner";
import { baseRouteMaker, routes } from "../../../../../../constants/routeConsts";
import { createPaymentIntent } from "../../../../../../redux/services/payments/paymentServices";
import { useStripe } from "@stripe/react-stripe-js";
import { toastService } from "../../../../../common/toast-messages/toast";

const GiftCard = withStripePayment(GiftCardPaymentDetails);

const GiftCardPaymentForm = () => {

  const stripe = useStripe();

  /* loading dependencies */
  const [loading, setLoading] = useState(false);
  const [submitLoader, setSubmitLoader] = useState(false);
  const [validateCouponCodeLoader, setValidateCouponCodeLoader] =
    useState(false);
  /* loading dependencies */

  /* dispatch an action */
  const dispatch = useDispatch();
  /* dispatch an action */

  /* navigation dependencies */
  const navigate = useNavigate();
  /* navigation dependencies */

  /* dialog dependencies */
  const [openPaymentConfirmationDialog, setOpenPaymentConfirmationDialog] =
    useState(false);
  /* dialog dependencies */

  const { loginDetails } = useSelector((state) => state.auth);

  const { confirmPurchaseGiftCardDetails } = useSelector(
    (state) => state.walletInfo
  );

  const createPayment = async (
    newCardToken,
    selectedCard,
    resetDefaultFields,
    pay_using_wallet_points
  ) => {

    const payment_method = selectedCard ? selectedCard : newCardToken?.card?.id;

    const dataToBeSent = {
      amount: confirmPurchaseGiftCardDetails?.amount,
      currency: confirmPurchaseGiftCardDetails?.currency,
      order_id: confirmPurchaseGiftCardDetails?._id,
      event_type: confirmPurchaseGiftCardDetails?.event_type,
      payment_method: payment_method,
      customer: loginDetails?.customer_stripe_token,
      new_card: newCardToken?.id ? true : false,
      token_id: newCardToken?.id || null
    };

    dispatch(createPaymentIntent(dataToBeSent, setSubmitLoader)).then(
      (apiRes) => {
        const paymentIntentResponse = apiRes;
        confirmCardPayment(resetDefaultFields, paymentIntentResponse, payment_method)
      }
    );
  };

  /* fuction definition to confirm card payment */
  const confirmCardPayment = async (resetDefaultFields, paymentIntentResponse, payment_method) => {
    if(paymentIntentResponse && paymentIntentResponse.id) {
      if(paymentIntentResponse.status === 'requires_action'){
        try {
          const confirmData = await stripe.confirmCardPayment(paymentIntentResponse.client_secret, {
            payment_method: payment_method,
          });
          if (confirmData.paymentIntent) {
            const dataToBeSent = {
              paymentIntentId: confirmData.paymentIntent.id
            }
            dispatch(getPaymentIntentAction(dataToBeSent, setSubmitLoader)).then((apiRes)=>{
              handleStripeResponse(resetDefaultFields, apiRes);
            })
          } else {
            toastService.error(confirmData?.error?.message);
            setSubmitLoader(false);
          }
        } catch (e) {
          toastService.error('Payment failed :' + e.message);
          setSubmitLoader(false);
        }
      }
      else {
        handleStripeResponse(resetDefaultFields, paymentIntentResponse);
      }
    }
}
/* fuction definition to confirm card payment */

/* function definition to check the payment intent status */
const handleStripeResponse = (resetDefaultFields, paymentIntentResponse) => {
  if (paymentIntentResponse.status === 'succeeded' || paymentIntentResponse.status === 'processing') {
    purchaseGiftCard(resetDefaultFields, paymentIntentResponse);
  }
  if (paymentIntentResponse.status === 'requires_payment_method') {
    toastService.error('Payment failed, please try again later');
    setSubmitLoader(false);
  }
}
/* function definition to check the payment intent status */

  const purchaseGiftCard = async (
    resetDefaultFields,
    paymentIntentResponse
  ) => {
    // Take subscription plan details
    const dataToBeSent = {
      payment_intent_id: paymentIntentResponse?.id,
      gift_card_id: confirmPurchaseGiftCardDetails?._id
    };


    dispatch(purchaseGiftCardAction(dataToBeSent, setSubmitLoader, setOpenPaymentConfirmationDialog, resetDefaultFields));
  };

  /* load initial card dependencies - get data of previously used card */
  useEffect(() => {
    if (
      Object.keys(confirmPurchaseGiftCardDetails)?.length === 0 ||
      confirmPurchaseGiftCardDetails === null ||
      confirmPurchaseGiftCardDetails === undefined
    ) {
      navigate(baseRouteMaker(routes.DASHBOARD));
    }
    dispatch(getAllCardsAction(setLoading));
    // eslint-disable-next-line react-hooks/exhaustive-deps

  }, []);
  /* load initial card dependencies - get data of previously used card */


  return loading ? (
    <Spinner />
  ) : ( 
    Object.keys(confirmPurchaseGiftCardDetails)?.length !== 0 &&
    confirmPurchaseGiftCardDetails !== null &&
    confirmPurchaseGiftCardDetails !== undefined && (
        <GiftCard
          submitLoader={submitLoader}
          createPayment={createPayment}
          openPaymentConfirmationDialog={openPaymentConfirmationDialog}
          setOpenPaymentConfirmationDialog={setOpenPaymentConfirmationDialog}
          validateCouponCode={()=>{}}
          validateCouponCodeLoader={validateCouponCodeLoader}
          showPayUsingWalletPointsCheckbox={false}
          applyCouponCode={false}
        />
      )
  );
};

export default React.memo(GiftCardPaymentForm);
